export default{
	domain:"www.yiyouhudong.cn",
	full_name:"广州益游互动网络科技有限公司",
	short_name:"广州益游",
	platform_name:"益游互动",
	address:"广州市天河区黄村路8号二楼A305",
	tel:"18022854632",
	fax:"13826416602",
	qq:"1619828831",
	email:"1619828831@qq.com",
	zip_code:"510000",
	web_icp:"粤ICP备18098164号-1",
	main_icp:"粤ICP备18098164号",
	ncol:"粤网文[2016]7021-1672号"//文网文
}


// WEBPACK FOOTER //
// ./src/config.js